import script from "./BeruView.vue?vue&type=script&lang=ts&setup=true"
export * from "./BeruView.vue?vue&type=script&lang=ts&setup=true"

import "./BeruView.vue?vue&type=style&index=0&id=4e4442d0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e4442d0"]])

export default __exports__